import React from "react";
import Home from "../Home/Home";
import About from "../About/About";
import Projects from "../Projects/Projects";
import Resume from "../Resume/ResumeNew";
import Achievements from "../Achievements/Achievements";

function Main({ homeRef, aboutRef, projectsRef, resumeRef, achievementsRef }) {
  return (
    <section>
      <div ref={homeRef}>
        <Home />
      </div>
      <div ref={aboutRef}>
        <About />
      </div>
      <div ref={projectsRef}>
        <Projects />
      </div>
      <div ref={achievementsRef}>
        <Achievements />
      </div>

      <div ref={resumeRef}>
        <Resume />
      </div>
    </section>
  );
}

export default Main;
